import { ListboxInput } from '@reach/listbox';
import styled from 'styled-components';

export const StyledListboxInput = styled(ListboxInput)`
	width: 100%;
	position: relative;
`;
